import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { AiAgentEnvService } from '../ai-agent-env-service';

@injectable()
export class AiAgentEnvServiceImpl implements AiAgentEnvService {

    get isInAiAgentFlow(): boolean {
        const data = this.isInIframe && this.win.location.href.includes('ai/agent-flow/');
        return data;
    }

    get isInIframe(): boolean {
        return window.self !== window.top;
    }

    get win() {
        return this.isInIframe ? window.parent : window;
    }
}
